import React, { useState } from 'react';
import FilterIcon from '../../assets/icons/filter_raw.svg';
import styles from './Contacts.module.scss';
import FilterModal from './FilterModal';
import { useContactsParams } from './useContactsParams';

const Filters = () => {
  const { params } = useContactsParams();
  const [showFilterModal, setShowFilterModal] = useState(false);

  const closeFilterModal = () => {
    setShowFilterModal(false);
  };

  return (
    <>
      <button
        className={styles.filter_button}
        type="button"
        onClick={() => setShowFilterModal(true)}
      >
        <FilterIcon
          height={24}
          width={24}
          className={`${params.filters !== undefined ? styles.fitlers_selected : ''}`}
        />
      </button>
      {showFilterModal && <FilterModal closeModal={closeFilterModal} />}
    </>
  );
};

export default Filters;
